/****************************************************
ManageUser.tsx - Manage user(add & delete) component for admin
*****************************************************/
import React, { useEffect, useState } from "react";
import { ImgAlert } from "../../../../../components/dashboard/pages/glovesSelector/glovesSelection";
import { reloadApp } from "../../../../common/functions/utils";
import "../Admin.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { fetchAPI, METHODS } from "../../../../../helper/functions/axios";
import { REGEX_VALIDATION } from "../../../../../helper/constants";
import UserInputModal from "../modalPopUp/userInputModal";
import { kclRootState } from "../../../../../store/gloveSelectorStore";
import SuccessModal from "../modalPopUp/successModal";
import { userDataTypes } from "../../../../../types/allTypes";
const addUserformData = {
  userId: "",
  userEmail: "",
  userRole: "Admin",
};

const ManageUser = () => {
  // const navigate = useNavigate();
  const { t } = useTranslation();
  const [showUser, setShowUser] = useState<boolean>(false);
  const [showAddUserPopUp, setAddUserPopUp] = useState<boolean>(false);
  const [showMessage, setMessage] = useState<string>('');
  const [showDelete, setShowDeleteUser] = useState<boolean>(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showErrorMessage, setError] = useState<string>('');
  const [form, setForm] = useState<typeof addUserformData>(addUserformData);
  const [emailError, setEmailError] = useState<boolean>(false);
  const [userIdError, setUserIdError] = useState<boolean>(false);
  const [addButtonActiveEmail, setAddButtonActiveEmail] = useState<boolean>(false);
  const [addButtonActiveId, setAddButtonActiveId] = useState<boolean>(false);
  const [userData, setUserData] = useState<Array<userDataTypes>>([]);
  const [alertFlag, setAlertFlag] = useState<boolean>(false);
  const [userDeleteID, setUserDeleteID] = useState<string>("");
  const { API_PATHS, PAGE_NAVIGATION, ERROR_MESSAGES } = useSelector(
    (state: kclRootState) => state?.glovesSelector?.config || {}
  );

  //fech user daetils on page load
  useEffect(() => {
    fetchUserDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchUserDetails = async () => {
    fetchAPI(METHODS.POST, API_PATHS.GET_ALL_USERS)
      .then((response) => {
        const reponseMessage = response?.data?.message || {};
        const reponseMessageIsSuccess = reponseMessage?.isSuccess;
        const reponseMessageError = reponseMessage?.result?.error;
        if (reponseMessageIsSuccess) {
          setUserData(reponseMessage?.result || "");
        }
        else {
          if (reponseMessageError === ERROR_MESSAGES.INVALID_TOKEN) {
            reloadApp(API_PATHS.GET_USER_LOGIN + PAGE_NAVIGATION.ADMIN_DASHBOARD);
          }
          else {
            setUserData([]);
          }
        }
      })
      .catch((error) => {
        setError(error);
      });
  };
  const handleInput = (e) => {
    e.preventDefault();
    const inputValue = e.target.value.toLowerCase();
    const inputName = e?.target?.name;
    const isEmailInputValid = REGEX_VALIDATION?.VALID_EMAIL_EXPRESSION?.test(inputValue);
    const isHidInputValid = REGEX_VALIDATION?.VALID_HID_EXPRESSION?.test(e?.target?.value);
    const inputLength = e?.target?.value.length;
    if (inputName === "userEmail") {
      const domain = inputValue.substring(inputValue.lastIndexOf("@"));
      if (isEmailInputValid && domain === "@honeywell.com") {
        setAddButtonActiveEmail(true);
        setEmailError(false);
      }
      else {
        if (inputValue.length > 0) {
          setEmailError(true);
          setAddButtonActiveEmail(false);
        }
        else {
          setEmailError(false);
        }
      }
    }
    else if (inputName === "userId") {
      if (isHidInputValid) {
        setAddButtonActiveId(true);
        setUserIdError(false);
      } else {

        if (inputLength > 0) {
          setUserIdError(true);
          setAddButtonActiveId(false);
        } else {
          setUserIdError(false);
        }
      }
    }
    setForm({ ...form, [e?.target?.name]: e?.target?.value });

  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchAPI(METHODS.POST, API_PATHS.ADD_USER, {
      userId: form.userId,
      userEmail: form.userEmail,
      userRole: form.userRole,
    })
      .then((response) => {
        const respIsSucess = response?.data?.message?.isSuccess;
        const respMessage: string = response?.data?.message?.result?.message || "";
        if (respIsSucess) {
          fetchUserDetails();
          setMessage(respMessage);
          if ((respMessage?.toLowerCase()?.includes("exists")) || (respMessage?.toLowerCase()?.includes("enter"))) {
            setAlertFlag(true);
          }
          else {
            setAlertFlag(false);
          }
          setAddUserPopUp(true);
        }
      })
      .catch((error) => {
        setError(error);
      });
    setForm(addUserformData);
    setShowUser(false);
    setShowDeleteUser(false);
  };

  const closeWarning = () => {
    setShowUser(false);
    setAddUserPopUp(false);
    setShowDeleteUser(false);
    setForm(addUserformData);
  };

  const deleteUser = () => {
    fetchAPI(METHODS.POST, API_PATHS.GET_DELETE_USERS, {
      userId: userDeleteID,
    })
      .then((response) => {
        const respIsSucess = response?.data?.message?.isSuccess;
        const respMessage = response?.data?.message?.result?.message;
        if (respIsSucess) {
          fetchUserDetails();
          setMessage(respMessage);
          setShowDeleteUser(true);
          setShowAlert(false);
        }
      });
  };

  const confirmDeleteOK = (userId) => {
    setUserDeleteID(userId);
    setShowAlert(true);
  };

  const confirmDeleteDenied = () => {
    setShowAlert(false);
  };

  return (
    <>
      {userData?.length > 0 &&
        <div className="user-list">
          <div className="main-title">
            <div className="textstart">
              <div className="heading">{t("manageUsers.Heading")}</div>
            </div>
            <div className="text-end btn-left-align">
              <div
                onClick={() => setShowUser(true)}
                className="button button-primary"
              >
                {t("manageUsers.Add_User")}
              </div>
            </div>
          </div>
          <div className="userlist-table">
            <div className="panel-body">
              <div className="table-head">
                <div className="table-items">
                  {t("manageUsers.TableHeaders.ColumneOne")}
                </div>
                <div className="table-items">
                  {t("manageUsers.TableHeaders.ColumneTwo")}
                </div>
                <div className="table-items">
                  {t("manageUsers.TableHeaders.ColumneThree")}
                </div>
              </div>
              {userData?.map((item, key) => {
                return (
                  <div className="row-entries" key={key}>
                    <div className="table-data">{item?.userId}</div>
                    <div className="table-data">{item?.userRole}</div>
                    <div className="table-data">
                      {item?.userRole === "SUPERADMIN" ? (
                        <div className="delete-user disable-btn">
                          {t("manageUsers.DeleteButton")}
                        </div>
                      ) : (
                        <div
                          className="delete-user"
                          onClick={() => confirmDeleteOK(item?.userId)}
                        >
                          {t("manageUsers.DeleteButton")}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>}

      <UserInputModal showUser={showUser} form={form} onChange={handleInput} onClick={handleSubmit} addButtonActiveEmail={addButtonActiveEmail} addButtonActiveId={addButtonActiveId} closeWarning={closeWarning} userIdError={userIdError} emailError={emailError} />
      <SuccessModal showPopUp={showAddUserPopUp} closeWarning={closeWarning} showMessage={showMessage} alertFlag={alertFlag} ariaLabel={'Add User'} />
      <SuccessModal showPopUp={showDelete} closeWarning={closeWarning} showMessage={showMessage} alertdangerFlag={true} ariaLabel={'Delete User'} />
      <SuccessModal showPopUp={showAlert} deleteOptionModal={true} confirmDeleteDenied={confirmDeleteDenied} img={ImgAlert} deleteUser={deleteUser} closeWarning={closeWarning} showMessage={showMessage} alertdangerFlag={true} ariaLabel={'Delete User'} />
    </>
  );
};
export default ManageUser;
